/**
 * Extract IMDb title IDs (tt…) from pasted URLs or plain text for search / import flows.
 * TMDb resolves these via /find?external_source=imdb_id (see tmdbService.getMovieById).
 */

const IMDB_TITLE_IN_URL = /(?:https?:\/\/)?(?:www\.|m\.)?imdb\.com\/title\/(tt\d{7,})\b/i;
const IMDB_ID_STANDALONE = /^(tt\d{7,})$/i;
const IMDB_ID_WORD = /\b(tt\d{7,})\b/i;

export function extractImdbIdFromSearchQuery(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  const fromUrl = trimmed.match(IMDB_TITLE_IN_URL);
  if (fromUrl?.[1]) return fromUrl[1].toLowerCase();

  if (IMDB_ID_STANDALONE.test(trimmed)) {
    return trimmed.toLowerCase();
  }

  const embedded = trimmed.match(IMDB_ID_WORD);
  return embedded?.[1] ? embedded[1].toLowerCase() : null;
}
